module.exports = __webpack_public_path__ + "static/media/backIcon.80debf07.svg";